export const environment = {
  env: 'PROD',
  production: true,
  groupOrderVersion: 'v3',
  googleAnalyticsDevMode : true,

  appUrl: "https://group-orders.freshprints.com/",
  hqUrl: 'https://hq.freshprints.com',
  adminV3Url: 'https://v3.freshprints.com/',
  mixpanelToken : "4121b0ca7f7295eff134fa50b37b33a5",
  designToolUrl: 'https://design-tool.freshprints.com',
  apiServerUrl: 'https://api-us.freshprints.com/',

  iterableConfig : {
    apiKey     : "4e58ad86daf44dbbb065ef3e81326153",
    eventUrl   : "https://api.iterable.com/api/events/track",
    userUrl    : "https://api.iterable.com/api/users/update"
  },

  cloudImageCdn: "https://alofmzptzp.cloudimg.io/v7/",

  GOOGLE_PAY_MERCHANT_ID: 'BCR2DN4TX7BZ3KKR',
};
